/**
 * Public custom cake request. Tammy edits size/flavour/filling in Product Options.
 */

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { applySeo } from '../utils/seo';
import { PAGE_SEO } from '../utils/seoDefaults';
import CakeRequestForm from './cakeRequest/CakeRequestForm';
import {
  CAKE_REQUEST_CATEGORY,
  CAKE_REQUEST_PATH,
  CAKE_REQUEST_PRINT_PATH,
  DEFAULT_CAKE_REQUEST_NOTICE,
  cakeRequestDropdowns,
} from './cakeRequest/cakeRequestOptions';

export default function CakeRequest() {
  const [lists, setLists] = useState(() => cakeRequestDropdowns([]));
  const [notice, setNotice] = useState(DEFAULT_CAKE_REQUEST_NOTICE);

  useEffect(() => {
    applySeo({
      ...PAGE_SEO.cakeRequest,
      og: {
        type: 'website',
        title: PAGE_SEO.cakeRequest.title,
        description: PAGE_SEO.cakeRequest.description,
      },
    });

    fetch(`/api/product-options?category=${encodeURIComponent(CAKE_REQUEST_CATEGORY)}`)
      .then((res) => (res.ok ? res.json() : { groups: [] }))
      .then((data) => setLists(cakeRequestDropdowns(data.groups || [])))
      .catch(() => undefined);

    fetch('/api/homepage-content')
      .then((res) => (res.ok ? res.json() : { cake_quote_notice: '' }))
      .then((data: { cake_quote_notice?: string }) => {
        if (data.cake_quote_notice) setNotice(data.cake_quote_notice);
      })
      .catch(() => undefined);
  }, []);

  return (
    <div className="section-padding bg-bakery-cream">
      <div className="container-custom max-w-xl">
        <h1 className="font-display text-4xl font-bold text-gray-900">Custom cake request</h1>
        <p className="mt-3 text-gray-700">
          Tell us size, flavour, filling, and your design. Tammy will call or email with a quote. Pickup at
          Commerce Park in Barrie.
        </p>
        <p className="mt-3 text-sm text-gray-600">
          In the store?{' '}
          <Link to={CAKE_REQUEST_PRINT_PATH} className="font-semibold text-primary-700 underline">
            Print the counter form
          </Link>{' '}
          (includes space to draw the design).
        </p>
        <div className="card mt-8 p-6 md:p-8">
          <CakeRequestForm lists={lists} notice={notice} />
        </div>
        <p className="mt-6 text-sm text-gray-600">
          Questions that are not a cake?{' '}
          <Link to="/contact" className="font-semibold text-primary-700 underline">
            Contact form
          </Link>
          .
        </p>
        <p className="sr-only">{CAKE_REQUEST_PATH}</p>
      </div>
    </div>
  );
}
